import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    fetch("/gallery.json")
      .then((res) => res.json())
      .then((data) => {
        if (mounted) setItems(data);
      })
      .catch(() => {})
      .finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, []);

  const visible = items;

  return (
    <div data-testid="gallery-page">
      <section className="w-full px-4 md:px-8 lg:px-12 pt-40 pb-12">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-chai-red mb-6">Frames By Chaied</p>
          <h1 className="font-heading font-bold uppercase tracking-tighter leading-[0.85] text-[13vw] md:text-[8vw]">
            Gallery
          </h1>
          <p className="font-body text-lg text-muted-foreground mt-6 max-w-xl">
            Storytelling through the lens — portraits, events and moments captured with a deliberate, editorial eye.
          </p>
        </Reveal>
      </section>

      <section className="w-full px-4 md:px-8 lg:px-12 pb-32">
        {loading ? (
          <p className="font-mono text-sm uppercase tracking-widest text-muted-foreground">Loading frames…</p>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 auto-rows-[240px]">
            {visible.map((item, i) => (
              <motion.button
                layout
                key={item.id}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: (i % 8) * 0.04 }}
                onClick={() => setActive(item)}
                className={`group relative overflow-hidden border border-chai-ink/15 ${
                  item.span === "tall" ? "row-span-2" : item.span === "wide" ? "md:col-span-2" : ""
                }`}
              >
                <img src={item.image_url} alt={item.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                <div className="absolute inset-0 bg-chai-ink/0 group-hover:bg-chai-ink/40 transition-colors flex items-end p-4">
                  <div className="translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all text-left">
                    <p className="font-mono text-[10px] uppercase tracking-widest text-chai-yellow">{item.category}</p>
                    <p className="font-heading text-white text-lg font-semibold leading-tight">{item.title}</p>
                  </div>
                </div>
              </motion.button>
            ))}
          </div>
        )}
      </section>
<AnimatePresence>
  {active && (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={() => setActive(null)}
      className="fixed inset-0 z-[60] bg-chai-ink/95 flex items-center justify-center p-4 md:p-12"
    >
      <button
        className="absolute top-6 right-6 text-white"
        onClick={() => setActive(null)}
        aria-label="Close"
      >
        <X size={36} />
      </button>
      <motion.div
  initial={{ scale: 0.92, opacity: 0 }}
  animate={{ scale: 1, opacity: 1 }}
  exit={{ scale: 0.92, opacity: 0 }}
  transition={{ ease: [0.76, 0, 0.24, 1] }}
  onClick={(e) => e.stopPropagation()}
  className="flex flex-col items-center justify-center w-full h-full"
>
  <div className="border-2 border-white/20 overflow-hidden flex justify-center items-center max-h-[90vh] max-w-[90vw]">
    <img
      src={active.image_url}
      alt={active.title}
      className="object-contain w-auto h-auto max-h-[90vh] max-w-[90vw] mx-auto my-auto"
    />
  </div>

  <div className="flex justify-between items-center mt-4 text-white w-full max-w-[90vw]">
    <p className="font-heading text-2xl font-semibold">{active.title}</p>
    <p className="font-mono text-xs uppercase tracking-widest text-chai-yellow">
      {active.category}
    </p>
  </div>
</motion.div>

    </motion.div>
  )}
</AnimatePresence>

      {/* <AnimatePresence>
        {active && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setActive(null)}
            className="fixed inset-0 z-[60] bg-chai-ink/95 flex items-center justify-center" // p-4 md:p-12"
          >
            <button className="absolute top-6 right-6 text-white" onClick={() => setActive(null)} aria-label="Close">
              <X size={36} />
            </button>
            <motion.div
              initial={{ scale: 0.92, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.92, opacity: 0 }}
              transition={{ ease: [0.76, 0, 0.24, 1] }}
              onClick={(e) => e.stopPropagation()}
              className="max-w-4xl w-full"
            >
              <div className="border-2 border-white/20 overflow-hidden max-h-[75vh]">
                <img src={active.image_url} alt={active.title} className="w-full h-full object-contain" />
              </div>
              <div className="flex justify-between items-center mt-4 text-white">
                <p className="font-heading text-2xl font-semibold">{active.title}</p>
                <p className="font-mono text-xs uppercase tracking-widest text-chai-yellow">{active.category}</p>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence> */}
    </div>
  );
}
